module.exports = __webpack_public_path__ + "static/img/record.bfd518bd.png";